import { useState } from "react";

export default function useToggle(initValue: boolean = false) {
  const [state, setState] = useState(initValue);
  const toggle = () => {
    setState((p) => !p);
  };
  const hide = () => {
    setState(false);
  };
  return [state, toggle, hide] as const;
}
